<!-- 
    notify插件 
-->
<template>
  <div class='notification'>
    <div class='toast-demo'>
      <i :class='["icon-"+iconType]' class='iconfont'/>
      <span>{{ msg }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: '',
      type: '',
    }
  },
  computed: {
    iconType() {
      let type
      switch (this.type) {
        case 'success':
          type = 'success'
          break
        case 'error':
          type = 'error'
          break
        default:
          type = 'warning'    
          break    
      }
      return type
    }
  }

}
</script>

<style lang="less" scoped>
.notification {
  width: 250px;
  height: 50px;
  padding: 10px;
  box-sizing: border-box;
  position: fixed;
  right: 10px;
  top: 10px;
  border-radius: 5px;
  background-color: #ffffff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  font-size: 14px;

  .icon-success {
    color: #67c23a;
    font-size: 25px;
  }

  .icon-error {
    color: #f56c6c;
    font-size: 22px;
  }

  .icon-warning {
    color: #e6a23c;
    font-size: 22px;
  }
}
</style>




// WEBPACK FOOTER //
// src/plugins/notification/Notification.vue